class ProfileImageStorage {
   static instance = null;
   static dbName = 'ProfileImageStorage';
   static storeName = 'profileImages';

   constructor() {
      this.db = null;
      this.initPromise = null;
   }

   async _ready() {
      if (this.db) return;
      if (this.initPromise === null) {
         this.initPromise = this._initDB().then(db => {
            this.db = db;
         });
      }
      await this.initPromise;
   }

   async _initDB() {
      return new Promise((resolve, reject) => {
         // Bump version to ensure store upgrade runs
         const request = indexedDB.open(ProfileImageStorage.dbName, 2);

         request.onupgradeneeded = event => {
            const db = event.target.result;

            // Create or recreate store
            if (!db.objectStoreNames.contains(ProfileImageStorage.storeName)) {
               db.createObjectStore(ProfileImageStorage.storeName, { keyPath: 'id' });
            }
         };

         request.onsuccess = () => resolve(request.result);
         request.onerror = () => reject('IndexedDB initialization failed');
      });
   }

   async save(id, blob) {
      await this._ready();
      const tx = this.db.transaction(ProfileImageStorage.storeName, 'readwrite');
      const record = {
         id, // must match keyPath
         blob,
         type: blob.type,
         size: blob.size,
         savedAt: Date.now(),
      };

      tx.objectStore(ProfileImageStorage.storeName).put(record);
      return tx.complete || tx.done;
   }

   async get(id) {
      await this._ready();
      return new Promise(resolve => {
         const tx = this.db.transaction(ProfileImageStorage.storeName, 'readonly');
         const req = tx.objectStore(ProfileImageStorage.storeName).get(id);

         req.onsuccess = () => resolve(req.result || null);
         req.onerror = () => resolve(null);
      });
   }

   async delete(id) {
      await this._ready();
      const tx = this.db.transaction(ProfileImageStorage.storeName, 'readwrite');
      tx.objectStore(ProfileImageStorage.storeName).delete(id);
      return tx.complete || tx.done;
   }

   async listAll() {
      await this._ready();
      const tx = this.db.transaction(ProfileImageStorage.storeName, 'readonly');
      const store = tx.objectStore(ProfileImageStorage.storeName);

      return new Promise((resolve, reject) => {
         const items = [];
         const request = store.openCursor();

         request.onsuccess = e => {
            const cursor = e.target.result;
            if (cursor) {
               items.push(cursor.value);
               cursor.continue();
            } else {
               resolve(items);
            }
         };

         request.onerror = () => reject('Failed to list items');
      });
   }

   async clear() {
      await this._ready();
      const tx = this.db.transaction(ProfileImageStorage.storeName, 'readwrite');
      tx.objectStore(ProfileImageStorage.storeName).clear();
      return tx.complete || tx.done;
   }
}

export const profileImageStorage = new ProfileImageStorage();
